if (!customElements.get('section-product')) {
  class TG_SectionProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.mediaIdIndexs = null;
      if(this.element.querySelector('[data-product-media-id-index-json]')){
        let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
        this.mediaIdIndexs = productMediaJsonData['media_id_index'];
      }

      this.productVariants = new themegoal.components_business.product_variants.ProductVariants(this.element, this.options);

      this._initStackGalleryCurrentImageStatus();
    
      //thumbs first
      this.productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
      this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
      
      if (this.productSlideshowNavElement) {
        this.productSlideshowNav = new themegoal.components.Carousel(this.productSlideshowNavElement);
      }

      if (this.productSlideshowElement) {
        if (!(this.options['galleryDesign'] == 'stack_carousel' && themegoal.helpers.Responsive.matchesBreakpoint('large'))){
          this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
        }
      }

      if (this.options['enableImageZoom']&&this.options['imageZoomLayout'] == 'stacked') {
        this.imageZoomInstance = new themegoal.components_business.product_variants.ProductImageModal(this.element);
      }

      let styleWithCarouselEle = this.element.querySelectorAll(".ProductStyleWith__Body .ProductList--carousel");

      this.styleWithCarousels = [];
      if (styleWithCarouselEle){
        let _this = this;
        styleWithCarouselEle.forEach(function (ele) {
          _this.styleWithCarousels.push(new themegoal.components.Carousel(ele));
        });
      }

      let offscreenElement = this.element.querySelector('.Site__TopLevelElment');

      if (offscreenElement) {
        document.body.appendChild(offscreenElement);
      }

      this.blockRecommendationsElementRelated = this.element.querySelector('.ProductBlockRecommendations--related');

      if (this.blockRecommendationsElementRelated) {
        this._loadRecommendations();
      }

      this.blockRecommendationsElementComplementary = this.element.querySelector('.ProductBlockRecommendations--complementary');

      if (this.blockRecommendationsElementComplementary) {
        this._loadRecommendationsComplementary();
      }

      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.productSlideshow)this.productSlideshow.destroy();
      if(this.productSlideshowNav)this.productSlideshowNav.destroy();
      if(this.styleWithCarousels){
        this.styleWithCarousels.forEach(function (carousel) {
          carousel.destroy();
        });
      }
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));

      this.delegateElement.on('variant:changed', this._updateStickAddToCartVariant.bind(this));

      if (this.options['galleryDesign'] == 'stack_carousel') {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }

    // KELAB: resolve which media-grouping entry a variant belongs to.
    // Mirrors the Liquid matching logic in the product-gallery / product-media
    // snippets, and the identical helper in component-product-variants.js, so
    // every layer agrees on grouping.
    //
    // Grouping list entries (from product.metafields.themegoal.media_grouping_set)
    // look like:
    //   "Case Type,start,end"                           -> default group for the whole Case Type
    //   "Case Type/Model,start,end"                      -> override for one specific Model
    //   "Case Type/Model A/Model B/Model C,start,end"     -> shared group for several Models
    //
    // Returns a string identifying the matched group. Two variants that resolve
    // to the same string share the same media group.
    _kelabGroupKey(options) {
      var groupingList = (window.__kelabMediaGroupings && window.__kelabMediaGroupings[this.options['productId']]) || [];
      var opt0 = (options[0] || '').toLowerCase().trim();
      var opt1 = (options[1] || '').toLowerCase().trim();
      var fallbackKey = null;

      for (var i = 0; i < groupingList.length; i++) {
        var parts = String(groupingList[i]).split(',');
        if (parts.length !== 3) continue;

        var keyParts = parts[0].trim().toLowerCase().split('/');
        var caseTypeKey = (keyParts[0] || '').trim();
        if (caseTypeKey !== opt0) continue;

        if (keyParts.length === 1) {
          fallbackKey = caseTypeKey;
          continue;
        }

        for (var j = 1; j < keyParts.length; j++) {
          if ((keyParts[j] || '').trim() === opt1) {
            return parts[0].trim().toLowerCase();
          }
        }
      }

      return fallbackKey !== null ? fallbackKey : opt0;
    }

    _updateStickAddToCartVariant(event){
      let variant = event.detail.variant;
      let previousVariant = event.detail.previousVariant;
      let productCardHorizontalElement = this.element.querySelector('.ProductStickyAddToCart');
      if(variant.available){
        let productCardHorizontalVariantTitleElement = this.element.querySelector('.ProductCardHorizontal__VariantTitle');

        if(productCardHorizontalVariantTitleElement){
          productCardHorizontalVariantTitleElement.innerHTML = variant.title;
        }

        if(productCardHorizontalElement.classList.contains("ProductStickyAddToCart--hidden")){
          productCardHorizontalElement.classList.remove("ProductStickyAddToCart--hidden");
        }
      }else{
        productCardHorizontalElement.classList.add("ProductStickyAddToCart--hidden");
      }

      let productCardHorizontalIdElement = this.element.querySelector('.ProductStickyAddToCart input[name="id"]');
      productCardHorizontalIdElement.setAttribute("value", variant.id);

      if (!variant || !variant['featured_image'] || previousVariant && previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
        return;
      }
  
      let newImage = variant['featured_image'];
      let mainImageContainer = productCardHorizontalElement.querySelector('.ProductCardHorizontal__ImageWrapper');
  
      let newImageElement = document.createElement('img');
      newImageElement.setAttribute('src', newImage['src']);
      mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));

    }

    _onBreakpointChanged(event) {
      let currentBreakpoint = event.detail.currentBreakpoint, previousBreakpoint = event.detail.previousBreakpoint;
      if (previousBreakpoint.indexOf("large") > -1 && currentBreakpoint.indexOf("large") < 0 ){
        this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
      }else if(previousBreakpoint.indexOf("large") < 0 && currentBreakpoint.indexOf("large") > -1 ){
        this.productSlideshow.destroy();
      }
    }

  
    _loadRecommendations() {
      var _this = this;
  
      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=related&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsRelatedCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;
  
          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--related .ProductBlockRecommendations__Body');
          
          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
  
          }else{
            _this.blockRecommendationsElementRelated.style.display = 'none';
          }
  
        });
      });
    }
  
    _loadRecommendationsComplementary() {
      var _this = this;
  
      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=complementary&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsComplementaryCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;
  
          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--complementary .ProductBlockRecommendations__Body');
          
          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
  
          }else{
            _this.blockRecommendationsElementComplementary.style.display = 'none';
          }
  
        });
      });
    }

    _isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    _stackItemSmoothScroll(stackItem){
      if(this._isInViewport(stackItem))return;
      const elementPosition = stackItem.getBoundingClientRect().top;
      let isStickyHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);

      //the document is currently scrolled vertically.
      const startTop = window.scrollY || window.pageYOffset;
      let offsetPosition = elementPosition + startTop - parseInt(document.documentElement.style.getPropertyValue('--tg-header-height') || 0) * isStickyHeader - (1 - isStickyHeader);

      //Gallery and summary are sticky, with the longer scroll coming first.
      let galleryElement = this.element.querySelector('.ProductGallery');
      let summaryElement = this.element.querySelector('.ProductSummary');
      if (galleryElement && summaryElement) {
        if(summaryElement.offsetHeight > galleryElement.offsetHeight){
          offsetPosition = offsetPosition + summaryElement.offsetHeight - galleryElement.offsetHeight;
        }
      }
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }

    _updateSlideshowImage(event) {
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;

      if (!variant || !variant['featured_media']) {
        return;
      }

      let variantFeaturedMediaId = variant['featured_media']['id'];
      let _this = this;
      let groupChanged = this.options["enableMediaGrouping"] && previousVariant && this._kelabGroupKey(previousVariant.options) !== this._kelabGroupKey(variant.options);

      // KELAB: only bail out when BOTH the native representative image and the
      // resolved media group are unchanged. A variant can keep the same native
      // featured_media (when it was never individually re-assigned per variant)
      // while still belonging to a different metafield-defined group - e.g.
      // switching Model into "iPhone 18 Fold" under the same Case Type. In
      // that case we must still run the update logic below.
      if (!groupChanged && previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variantFeaturedMediaId) {
        return;
      }

      let reloadMediaIndex = function () {
        _this.mediaIdIndexs = null;
        if (_this.element.querySelector('[data-product-media-id-index-json]')) {
          let productMediaJsonData = JSON.parse(_this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
          _this.mediaIdIndexs = productMediaJsonData['media_id_index'];
        }
      };

      // 按当前渲染出的 DOM 顺序找目标是第几个（0-based）
      let cellIndexByDom = function (mediaId) {
        let items = _this.element.querySelectorAll('.ProductGallery__Carousel .Carousel__Item[data-media-id]');
        for (let i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') == mediaId) return i;
        }
        return -1;
      };

      if (this.options['galleryDesign'] == 'carousel') {
        if (groupChanged) {
          // KELAB: 先销毁旧 carousel 实例，避免 loop/virtual 克隆滑块残留导致乱序
          if (this.productSlideshow && typeof this.productSlideshow.destroy === 'function') {
            this.productSlideshow.destroy();
          }
          if (this.productSlideshowNav && typeof this.productSlideshowNav.destroy === 'function') {
            this.productSlideshowNav.destroy();
          }

          reloadMediaIndex();
          this.productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
          this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');

          if (this.productSlideshowNavElement) {
            this.productSlideshowNav = new themegoal.components.Carousel(this.productSlideshowNavElement);
          }
          if (this.productSlideshowElement) {
            this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
          }
          // 重建完成后停到当前组第一张
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              if (_this.productSlideshow && typeof _this.productSlideshow.selectCell === 'function') {
                _this.productSlideshow.selectCell(0);
              }
            });
          });
        } else {
          let idx = cellIndexByDom(variantFeaturedMediaId);
          if (idx < 0) idx = 0;
          if (this.productSlideshow && typeof this.productSlideshow.selectCell === 'function') {
            this.productSlideshow.selectCell(idx);
          }
        }
      } else if (this.options['galleryDesign'] == 'stack_images'){
        let stackElement = this.element.querySelector(".ProductGallery--stack");
        if(stackElement){
          let stackItems = stackElement.querySelectorAll('.Product__MediaWrapper');
          stackItems.forEach(function (item) {
            item.classList.remove("Product__MediaWrapper--currentVariantImage");
          });
          let stackItem = stackElement.querySelector('[data-media-id="'+ variantFeaturedMediaId +'"]');
          if (stackItem) {
            stackItem.classList.add("Product__MediaWrapper--currentVariantImage");
            this.imageBreakpoint = themegoal.helpers.Responsive.getCurrentBreakpoint();
            if(this.imageBreakpoint != 'small' && this.imageBreakpoint != 'medium'){
              this._stackItemSmoothScroll(stackItem);
            }else{
              stackItem.scrollIntoView({ behavior: 'smooth', block:"nearest", container:"nearest", inlline:"center"});
            }
          }
        }
      } else if (this.options['galleryDesign'] == 'stack_carousel'){
        if (themegoal.helpers.Responsive.matchesBreakpoint('large')) {
          let stackElement = this.element.querySelector(".ProductGallery--stackCarousel");
          if(stackElement){
            let stackItems = stackElement.querySelectorAll('.MediaModalOpener');
            stackItems.forEach(function (item) {
              item.classList.remove("MediaModalOpener--currentVariantImage");
            });
            let stackItem = stackElement.querySelector('[data-media-id="'+ variantFeaturedMediaId +'"]');
            if (stackItem) {
              stackItem.classList.add("MediaModalOpener--currentVariantImage");
              this._stackItemSmoothScroll(stackItem);
            }
          }
        }else{
          if (groupChanged) {
            if (this.productSlideshow && typeof this.productSlideshow.destroy === 'function') {
              this.productSlideshow.destroy();
            }
            this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
            if (this.productSlideshowElement) {
              this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
            }
            reloadMediaIndex();
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                if (_this.productSlideshow && typeof _this.productSlideshow.selectCell === 'function') {
                  _this.productSlideshow.selectCell(0);
                }
              });
            });
          } else {
            let idx = cellIndexByDom(variantFeaturedMediaId);
            if (idx < 0) idx = 0;
            if (this.productSlideshow && typeof this.productSlideshow.selectCell === 'function') {
              this.productSlideshow.selectCell(idx);
            }
          }
        }
      }
    }
  
    _initStackGalleryCurrentImageStatus(){
      if (this.options['galleryDesign'] == 'stack_images'){
        let stackElement = this.element.querySelector(".ProductGallery--stack");
  
        if(stackElement){
          let stackItems = stackElement.querySelectorAll('.Product__MediaWrapper');
          stackItems.forEach(function (item) {
            item.classList.remove("Product__MediaWrapper--currentVariantImage");
          });
  
          let stackItem = stackElement.querySelector('[data-media-id="'+ this.options['initCurrentVariantImageId'] +'"]');
  
          if(stackItem){
            stackItem.classList.add("Product__MediaWrapper--currentVariantImage");
            // do not scroll when page loading
            // stackItem.scrollIntoView({ behavior: 'smooth', block:"start"});
          }
        }
        
      } 
    }
    
  }
    
  customElements.define('section-product', TG_SectionProduct);
}